module.exports = __webpack_public_path__ + "static/img/monsters.318ba86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/monsters.png
// module id = 5r+v
// module chunks = 0